const topics = [
  { tag: '暑期档', title: '暑期档票房突破80亿，国产片表现亮眼', hot: '9.8w', color: 'primary' },
  { tag: '新剧开播', title: '《大秦帝国》系列新作定档8月上线', hot: '7.2w', color: 'accent' },
  { tag: '综艺热播', title: '《奔跑吧》新一季嘉宾阵容曝光引热议', hot: '6.5w', color: 'secondary' },
  { tag: '影评', title: '豆瓣8.5分以上必看华语电影大盘点', hot: '5.9w', color: 'primary' },
  { tag: '动漫', title: '国漫《深海》获国际动画电影节大奖', hot: '5.1w', color: 'accent' },
  { tag: '院线', title: 'IMAX影院暑期观影指南：这些大片值得一看', hot: '4.8w', color: 'secondary' },
  { tag: '追剧', title: '8月待播剧清单：悬疑、甜宠一应俱全', hot: '4.3w', color: 'primary' },
  { tag: '纪录片', title: 'BBC年度纪录片《地球脉动III》中配版上线', hot: '3.9w', color: 'accent' },
  { tag: '经典', title: '周星驰经典喜剧电影高清修复版合集', hot: '3.6w', color: 'secondary' },
  { tag: '海外', title: 'Netflix亚洲原创内容持续发力引关注', hot: '3.2w', color: 'primary' },
];

const colorMap: Record<string, { bg: string; text: string; dot: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', dot: 'bg-primary-500' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', dot: 'bg-accent-500' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', dot: 'bg-secondary-500' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            影视圈最新动态与热门讨论，不错过任何精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {topics.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.title}
                className="group bg-background-100 hover:bg-background-200/80 rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer border border-background-200/60 hover:border-background-300/60"
              >
                <div className="flex items-center gap-2 mb-3">
                  <span className={`inline-block px-2.5 py-1 rounded-md text-[11px] font-semibold whitespace-nowrap ${c.bg} ${c.text}`}>
                    {item.tag}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-fire-line text-xs"></i>
                    {item.hot}
                  </span>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-relaxed line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-3 pt-3 border-t border-background-200/40">
                  <div className={`w-1.5 h-1.5 rounded-full ${c.dot}`}></div>
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">今日更新</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}